<div class="modal-container">
  <div class="modal-header no-print">
    <h2 mat-dialog-title>
      <mat-icon>print</mat-icon>
      <span>Necessidade de materiais</span>
    </h2>
    <button mat-icon-button (click)="fechar()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="content-body modal-print-container">
    @if (carregandoEmpresa) {
    <div class="loading-container no-print">Carregando...</div>
    } @else {
    @for (ordem of data.ordens; track ordem.idOrdemProducao; let ultima = $last) {
    <div class="documento-pagina" [class.documento-pagina--quebra]="!ultima">
      <div class="documento-cabecalho">
        @if (empresaLogo) {
        <img [src]="empresaLogo" class="documento-logo" alt="Logo da empresa" />
        }
        <div>
          <strong>{{ empresaNome }}</strong>
          @if (empresaEndereco) {
          <div class="documento-empresa-detalhe">{{ empresaEndereco }}</div>
          }
          @if (empresaCnpj) {
          <div class="documento-empresa-detalhe">CNPJ: {{ empresaCnpj }}</div>
          }
        </div>
      </div>

      <h3 class="documento-titulo">Necessidade de materiais Nº {{ ordem.numero }}</h3>

      <div class="documento-identificacao">
        <div><span class="documento-label">Código (SKU)</span><span>{{ ordem.codigoSku }}</span></div>
        <div><span class="documento-label">Produto</span><span>{{ ordem.nomeProduto }}</span></div>
        <div>
          <span class="documento-label">Quantidade</span>
          <span>{{ ordem.quantidade | abnt:'quantidade':(ordem.isUnidadeMedidaFracionada ? undefined : 0) }} {{ ordem.unidade }}</span>
        </div>
        <div><span class="documento-label">Data início</span><span>{{ ordem.dataInicio | date:'dd/MM/yyyy' }}</span></div>
        <div>
          <span class="documento-label">Data prevista</span>
          <span>{{ ordem.dataPrevistaTermino ? (ordem.dataPrevistaTermino | date:'dd/MM/yyyy') : '--' }}</span>
        </div>
      </div>

      <h4 class="documento-subtitulo">Matérias-primas</h4>
      <table class="documento-tabela">
        <thead>
          <tr>
            <th>Produto</th>
            <th>Código (SKU)</th>
            <th>Unidade</th>
            <th class="text-end">Quantidade</th>
            <th class="text-end">Estoque Atual</th>
          </tr>
        </thead>
        <tbody>
          @for (item of ordem.itens; track item.idOrdemProducaoItem) {
          <tr>
            <td>{{ item.nomeProduto }}</td>
            <td>{{ item.codigoSku }}</td>
            <td>{{ item.unidade }}</td>
            <td class="text-end">{{ item.quantidadeTotal | abnt:'quantidade':(item.isUnidadeMedidaFracionada ? undefined : 0) }}</td>
            <td class="text-end" [class.documento-negativo]="(estoqueApos(item.saldoAtual, item.quantidadeTotal) ?? 0) < 0">
              {{ item.saldoAtual === null ? '--' : (estoqueApos(item.saldoAtual, item.quantidadeTotal) | abnt:'quantidade':(item.isUnidadeMedidaFracionada ? undefined : 0)) }}
            </td>
          </tr>
          }
        </tbody>
      </table>

      <h4 class="documento-subtitulo">Observações</h4>
      @if (ordem.observacoes) {
      <p class="documento-observacoes">{{ ordem.observacoes }}</p>
      } @else {
      <p class="documento-observacoes documento-observacoes--vazio">Nenhuma observação registrada.</p>
      }
    </div>
    }
    }
  </div>

  <div class="modal-footer no-print">
    <button mat-stroked-button class="btn-secondary" (click)="fechar()">Cancelar</button>
    @if (!carregandoEmpresa) {
    <button mat-flat-button class="btn-primary" (click)="imprimir()">
      <mat-icon>print</mat-icon> Imprimir
    </button>
    }
  </div>
</div>
